module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar navbar-default navbar-static-top",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "navbar-brand"
  }, [_vm._v("\n\t\t\t\tСемейна образователна мрежа "), _c('img', {
    attrs: {
      "src": "/network/static/img/sun.png",
      "alt": "FEN",
      "title": "FEN",
      "height": "40"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "pull-right my-1",
    attrs: {
      "href": "/network/logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _vm._v(" Изход")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer text-center my-1",
    attrs: {
      "id": "footer"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.homeschoolingbg.com",
      "target": "_blank"
    }
  }, [_vm._v("Асоциация за домашно образование")]), _vm._v(" © 2017 Всички права запазени. Версия 0.0.1\n\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-377a160b!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/NoSideMenuView.vue
// module id = 648
// module chunks = 1